import { render, staticRenderFns } from "./AvatarTextContent.vue?vue&type=template&id=1974242e"
import script from "./AvatarTextContent.vue?vue&type=script&lang=js"
export * from "./AvatarTextContent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports